import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function GamificacaoJogos() {
  const [jogoAtivo, setJogoAtivo] = useState('bingo');

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Jogos & Sorteios</h1>
            <p className="text-sm text-gray-600 mt-1">Administração de jogos vinculados a XP</p>
          </div>
        </div>

        {/* Menu de Jogos */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="border-b border-gray-200">
            <div className="flex gap-1 p-1">
              {[
                { id: 'bingo', label: 'Bingo', icon: 'ri-grid-fill' },
                { id: 'roleta', label: 'Roleta de Prêmios', icon: 'ri-refresh-line' },
                { id: 'raspadinha', label: 'Raspadinha', icon: 'ri-ticket-2-line' },
                { id: 'rifa', label: 'Rifa', icon: 'ri-coupon-3-line' },
                { id: 'palpites', label: 'Palpites da Copa', icon: 'ri-football-line' },
              ].map((jogo) => (
                <button
                  key={jogo.id}
                  onClick={() => setJogoAtivo(jogo.id)}
                  className={`flex-1 px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                    jogoAtivo === jogo.id
                      ? 'bg-teal-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <i className={`${jogo.icon} mr-2`}></i>
                  {jogo.label}
                </button>
              ))}
            </div>
          </div>

          <div className="p-6">
            {/* Bingo */}
            {jogoAtivo === 'bingo' && <BingoAdmin />}
            
            {/* Roleta */}
            {jogoAtivo === 'roleta' && <RoletaAdmin />}
            
            {/* Raspadinha */}
            {jogoAtivo === 'raspadinha' && <RaspadinhaAdmin />}
            
            {/* Rifa */}
            {jogoAtivo === 'rifa' && <RifaAdmin />}
            
            {/* Palpites */}
            {jogoAtivo === 'palpites' && <PalpitesAdmin />}
          </div>
        </div>
      </div>
    </Layout>
  );
}

// Componente Bingo
function BingoAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [showVencedoresModal, setShowVencedoresModal] = useState(false);
  const [selectedSessao, setSelectedSessao] = useState<any>(null);

  const sessoes = [
    { id: 1, titulo: 'Bingo de Vendas Janeiro', data: '20/01/2024 19:00', max_participantes: 100, participantes: 87, premios: 'R$ 5.000', status: 'Agendado' },
    { id: 2, titulo: 'Bingo Especial Fim de Ano', data: '31/12/2023 20:00', max_participantes: 150, participantes: 150, premios: 'R$ 10.000', status: 'Concluído' },
  ];

  const handleEdit = (sessao: any) => {
    setSelectedSessao(sessao);
    setShowEditModal(true);
  };

  const handleViewLogs = (sessao: any) => {
    setSelectedSessao(sessao);
    setShowLogsModal(true);
  };

  const handleViewVencedores = (sessao: any) => {
    setSelectedSessao(sessao);
    setShowVencedoresModal(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-gray-900">Sessões de Bingo</h2>
        <button
          onClick={() => setShowModal(true)}
          className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
        >
          <i className="ri-add-line mr-2"></i>
          Nova Sessão
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Título</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Data/Hora</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Participantes</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Prêmios</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Status</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Ações</th>
            </tr>
          </thead>
          <tbody>
            {sessoes.map((sessao) => (
              <tr key={sessao.id} className="border-t border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{sessao.titulo}</td>
                <td className="py-3 px-4 text-center text-sm text-gray-700">{sessao.data}</td>
                <td className="py-3 px-4 text-center text-sm text-gray-700">{sessao.participantes}/{sessao.max_participantes}</td>
                <td className="py-3 px-4 text-center text-sm font-bold text-green-600">{sessao.premios}</td>
                <td className="py-3 px-4 text-center">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    sessao.status === 'Agendado' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
                  }`}>
                    {sessao.status}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center justify-center gap-2">
                    <button 
                      onClick={() => handleEdit(sessao)}
                      className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded transition-colors"
                      title="Editar"
                    >
                      <i className="ri-edit-line text-base"></i>
                    </button>
                    <button 
                      onClick={() => handleViewLogs(sessao)}
                      className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                      title="Logs de Bolas Sorteadas"
                    >
                      <i className="ri-play-circle-line text-base"></i>
                    </button>
                    <button 
                      onClick={() => handleViewVencedores(sessao)}
                      className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded transition-colors"
                      title="Ver Vencedores"
                    >
                      <i className="ri-trophy-line text-base"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Nova Sessão */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Nova Sessão de Bingo</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Título *</label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data *</label>
                  <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Hora *</label>
                  <input type="time" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Máximo de Participantes *</label>
                <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Prêmios</label>
                <textarea rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Descreva os prêmios da sessão"></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Regras</label>
                <textarea rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Descreva as regras do bingo"></textarea>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Criar Sessão</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {showEditModal && selectedSessao && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Editar Sessão de Bingo</h3>
              <button onClick={() => setShowEditModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Título *</label>
                <input type="text" defaultValue={selectedSessao.titulo} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data *</label>
                  <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Hora *</label>
                  <input type="time" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Máximo de Participantes *</label>
                <input type="number" defaultValue={selectedSessao.max_participantes} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Prêmios</label>
                <textarea rows={3} defaultValue={selectedSessao.premios} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Regras</label>
                <textarea rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"></textarea>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Salvar Alterações</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Logs de Bolas Sorteadas */}
      {showLogsModal && selectedSessao && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Logs de Bolas Sorteadas</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedSessao.titulo}</p>
              </div>
              <button onClick={() => setShowLogsModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-10 gap-2">
                {[15, 23, 42, 7, 31, 56, 12, 68, 3, 49, 27, 61, 8, 35, 52, 19, 44, 2, 38, 65].map((bola, index) => (
                  <div key={index} className="aspect-square bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                    {bola}
                  </div>
                ))}
              </div>
              <div className="mt-6 bg-gray-50 rounded-lg p-4">
                <h4 className="text-sm font-semibold text-gray-900 mb-3">Histórico de Sorteios</h4>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {[
                    { numero: 15, horario: '19:05:23', tipo: 'Normal' },
                    { numero: 23, horario: '19:06:45', tipo: 'Normal' },
                    { numero: 42, horario: '19:08:12', tipo: 'Normal' },
                    { numero: 7, horario: '19:09:34', tipo: 'Normal' },
                    { numero: 31, horario: '19:11:02', tipo: 'Normal' },
                  ].map((log, index) => (
                    <div key={index} className="flex items-center justify-between text-sm bg-white rounded p-2">
                      <span className="font-medium text-gray-900">Bola {log.numero}</span>
                      <span className="text-gray-600">{log.horario}</span>
                      <span className="text-xs px-2 py-1 bg-teal-100 text-teal-800 rounded-full">{log.tipo}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowLogsModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Vencedores */}
      {showVencedoresModal && selectedSessao && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Lista de Vencedores</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedSessao.titulo}</p>
              </div>
              <button onClick={() => setShowVencedoresModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Posição</th>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Participante</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Tipo</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Prêmio</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Horário</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { posicao: '1º', nome: 'João Silva', email: 'joao@email.com', tipo: 'Bingo Completo', premio: 'R$ 3.000', horario: '19:45:23' },
                      { posicao: '2º', nome: 'Maria Santos', email: 'maria@email.com', tipo: 'Linha', premio: 'R$ 1.000', horario: '19:32:15' },
                      { posicao: '3º', nome: 'Pedro Costa', email: 'pedro@email.com', tipo: 'Linha', premio: 'R$ 1.000', horario: '19:28:45' },
                    ].map((vencedor, index) => (
                      <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                        <td className="py-3 px-4">
                          <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold ${
                            index === 0 ? 'bg-yellow-100 text-yellow-800' : 
                            index === 1 ? 'bg-gray-200 text-gray-800' : 
                            'bg-orange-100 text-orange-800'
                          }`}>
                            {vencedor.posicao}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <div>
                            <p className="text-sm font-medium text-gray-900">{vencedor.nome}</p>
                            <p className="text-xs text-gray-600">{vencedor.email}</p>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-center">
                          <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                            {vencedor.tipo}
                          </span>
                        </td>
                        <td className="py-3 px-4 text-center text-sm font-bold text-green-600">{vencedor.premio}</td>
                        <td className="py-3 px-4 text-center text-sm text-gray-700">{vencedor.horario}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowVencedoresModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Componente Roleta
function RoletaAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [selectedRoleta, setSelectedRoleta] = useState<any>(null);
  const [segmentos, setSegmentos] = useState([
    { premio: '100 XP', probabilidade: 30, xp: 100 },
    { premio: '200 XP', probabilidade: 25, xp: 200 },
    { premio: '500 XP', probabilidade: 20, xp: 500 },
    { premio: '1000 XP', probabilidade: 15, xp: 1000 },
  ]);

  const roletas = [
    { id: 1, nome: 'Roleta Premium', segmentos: 8, xp_girar: 50, total_giros: 1234, status: 'Ativa' },
    { id: 2, nome: 'Roleta VIP', segmentos: 12, xp_girar: 100, total_giros: 567, status: 'Ativa' },
  ];

  const handleEdit = (roleta: any) => {
    setSelectedRoleta(roleta);
    setShowEditModal(true);
  };

  const handleViewStats = (roleta: any) => {
    setSelectedRoleta(roleta);
    setShowStatsModal(true);
  };

  const addSegmento = () => {
    setSegmentos([...segmentos, { premio: '', probabilidade: 0, xp: 0 }]);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-gray-900">Roletas de Prêmios</h2>
        <button onClick={() => setShowModal(true)} className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
          <i className="ri-add-line mr-2"></i>
          Nova Roleta
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {roletas.map((roleta) => (
          <div key={roleta.id} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-lg font-bold text-gray-900">{roleta.nome}</h3>
                <p className="text-sm text-gray-600 mt-1">{roleta.segmentos} segmentos</p>
              </div>
              <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">{roleta.status}</span>
            </div>
            <div className="space-y-2 mb-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">XP para Girar:</span>
                <span className="font-bold text-yellow-600">{roleta.xp_girar} XP</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Total de Giros:</span>
                <span className="font-bold text-teal-600">{roleta.total_giros}</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button 
                onClick={() => handleEdit(roleta)}
                className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
              >
                <i className="ri-edit-line mr-2"></i>
                Editar
              </button>
              <button 
                onClick={() => handleViewStats(roleta)}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium whitespace-nowrap"
              >
                <i className="ri-bar-chart-line mr-2"></i>
                Estatísticas
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Nova Roleta */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <h3 className="text-xl font-bold text-gray-900">Nova Roleta de Prêmios</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Roleta *</label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Número de Segmentos *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP para Girar *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cooldown (minutos)</label>
                <input type="number" placeholder="Tempo para girar novamente" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium text-gray-700">Definir Segmentos e Probabilidades</label>
                  <button 
                    onClick={addSegmento}
                    className="px-3 py-1 bg-teal-600 text-white rounded text-xs font-medium hover:bg-teal-700 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-add-line mr-1"></i>
                    Adicionar
                  </button>
                </div>
                <p className="text-xs text-gray-500 mb-2">Configure cada segmento da roleta</p>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  <div className="grid grid-cols-3 gap-2 text-xs font-medium text-gray-600 mb-1">
                    <span>Prêmio</span>
                    <span>Probabilidade (%)</span>
                    <span>XP Prêmio</span>
                  </div>
                  {segmentos.map((seg, i) => (
                    <div key={i} className="grid grid-cols-3 gap-2">
                      <input 
                        type="text" 
                        placeholder="Ex: 100 XP" 
                        defaultValue={seg.premio}
                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" 
                      />
                      <input 
                        type="number" 
                        placeholder="%" 
                        defaultValue={seg.probabilidade}
                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" 
                      />
                      <input 
                        type="number" 
                        placeholder="XP" 
                        defaultValue={seg.xp}
                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" 
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Criar Roleta</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {showEditModal && selectedRoleta && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <h3 className="text-xl font-bold text-gray-900">Editar Roleta de Prêmios</h3>
              <button onClick={() => setShowEditModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Roleta *</label>
                <input type="text" defaultValue={selectedRoleta.nome} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Número de Segmentos *</label>
                  <input type="number" defaultValue={selectedRoleta.segmentos} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP para Girar *</label>
                  <input type="number" defaultValue={selectedRoleta.xp_girar} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cooldown (minutos)</label>
                <input type="number" placeholder="Tempo para girar novamente" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Salvar Alterações</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Estatísticas */}
      {showStatsModal && selectedRoleta && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Estatísticas da Roleta</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedRoleta.nome}</p>
              </div>
              <button onClick={() => setShowStatsModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-6">
              {/* KPIs */}
              <div className="grid grid-cols-4 gap-4">
                <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg p-4 text-white">
                  <p className="text-sm opacity-90">Total de Giros</p>
                  <p className="text-3xl font-bold mt-1">{selectedRoleta.total_giros}</p>
                </div>
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg p-4 text-white">
                  <p className="text-sm opacity-90">XP Distribuído</p>
                  <p className="text-3xl font-bold mt-1">156.8K</p>
                </div>
                <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg p-4 text-white">
                  <p className="text-sm opacity-90">Participantes</p>
                  <p className="text-3xl font-bold mt-1">487</p>
                </div>
                <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg p-4 text-white">
                  <p className="text-sm opacity-90">Taxa de Conversão</p>
                  <p className="text-3xl font-bold mt-1">68%</p>
                </div>
              </div>

              {/* Distribuição de Prêmios */}
              <div>
                <h4 className="text-sm font-semibold text-gray-900 mb-3">Distribuição de Prêmios</h4>
                <div className="space-y-2">
                  {[
                    { premio: '100 XP', quantidade: 456, percentual: 37 },
                    { premio: '200 XP', quantidade: 312, percentual: 25 },
                    { premio: '500 XP', quantidade: 234, percentual: 19 },
                    { premio: '1000 XP', quantidade: 156, percentual: 13 },
                    { premio: '5000 XP', quantidade: 76, percentual: 6 },
                  ].map((item, index) => (
                    <div key={index} className="bg-gray-50 rounded-lg p-3">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-medium text-gray-900">{item.premio}</span>
                        <span className="text-sm text-gray-600">{item.quantidade} giros ({item.percentual}%)</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-teal-500 h-2 rounded-full" style={{ width: `${item.percentual}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Últimos Resultados */}
              <div>
                <h4 className="text-sm font-semibold text-gray-900 mb-3">Últimos Resultados</h4>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="text-left py-2 px-3 text-xs font-semibold text-gray-700">Participante</th>
                        <th className="text-center py-2 px-3 text-xs font-semibold text-gray-700">Prêmio</th>
                        <th className="text-center py-2 px-3 text-xs font-semibold text-gray-700">Data/Hora</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { nome: 'João Silva', premio: '1000 XP', data: '15/01/2024 14:23' },
                        { nome: 'Maria Santos', premio: '200 XP', data: '15/01/2024 14:15' },
                        { nome: 'Pedro Costa', premio: '500 XP', data: '15/01/2024 14:08' },
                        { nome: 'Ana Oliveira', premio: '100 XP', data: '15/01/2024 13:56' },
                      ].map((resultado, index) => (
                        <tr key={index} className="border-t border-gray-100">
                          <td className="py-2 px-3 text-sm text-gray-900">{resultado.nome}</td>
                          <td className="py-2 px-3 text-center">
                            <span className="inline-flex items-center px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">
                              {resultado.premio}
                            </span>
                          </td>
                          <td className="py-2 px-3 text-center text-sm text-gray-600">{resultado.data}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowStatsModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Componente Raspadinha
function RaspadinhaAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [selectedSerie, setSelectedSerie] = useState<any>(null);

  const series = [
    { id: 1, nome: 'Série Ouro', total_cards: 1000, raspados: 678, xp_raspar: 30, probabilidade: '15%', status: 'Ativa' },
    { id: 2, nome: 'Série Prata', total_cards: 500, raspados: 234, xp_raspar: 20, probabilidade: '20%', status: 'Ativa' },
  ];

  const handleEdit = (serie: any) => {
    setSelectedSerie(serie);
    setShowEditModal(true);
  };

  const handleViewLogs = (serie: any) => {
    setSelectedSerie(serie);
    setShowLogsModal(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-gray-900">Séries de Raspadinhas</h2>
        <button onClick={() => setShowModal(true)} className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
          <i className="ri-add-line mr-2"></i>
          Nova Série
        </button>
      </div>

      <div className="space-y-3">
        {series.map((serie) => (
          <div key={serie.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-sm font-bold text-gray-900">{serie.nome}</h3>
                <div className="grid grid-cols-4 gap-4 mt-2">
                  <div>
                    <p className="text-xs text-gray-600">Total de Cards</p>
                    <p className="text-sm font-bold text-gray-900">{serie.total_cards}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-600">Raspados</p>
                    <p className="text-sm font-bold text-teal-600">{serie.raspados}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-600">XP para Raspar</p>
                    <p className="text-sm font-bold text-yellow-600">{serie.xp_raspar} XP</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-600">Probabilidade</p>
                    <p className="text-sm font-bold text-green-600">{serie.probabilidade}</p>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 ml-4">
                <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">{serie.status}</span>
                <button 
                  onClick={() => handleEdit(serie)}
                  className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded transition-colors"
                  title="Editar"
                >
                  <i className="ri-edit-line text-base"></i>
                </button>
                <button 
                  onClick={() => handleViewLogs(serie)}
                  className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                  title="Ver Logs"
                >
                  <i className="ri-file-list-3-line text-base"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Nova Série */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Nova Série de Raspadinhas</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Série *</label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Total de Cards *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP para Raspar *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Probabilidade Global (%)</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Criar Série</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {showEditModal && selectedSerie && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Editar Série de Raspadinhas</h3>
              <button onClick={() => setShowEditModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Série *</label>
                <input type="text" defaultValue={selectedSerie.nome} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Total de Cards *</label>
                  <input type="number" defaultValue={selectedSerie.total_cards} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP para Raspar *</label>
                  <input type="number" defaultValue={selectedSerie.xp_raspar} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Probabilidade Global (%)</label>
                  <input type="number" defaultValue={selectedSerie.probabilidade} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Salvar Alterações</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Logs */}
      {showLogsModal && selectedSerie && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Logs de Raspadinhas</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedSerie.nome}</p>
              </div>
              <button onClick={() => setShowLogsModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Participante</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Resultado</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Ganho</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Data/Hora</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { nome: 'João Silva', email: 'joao@email.com', resultado: 'Ganhou', xp: 500, data: '15/01/2024 14:23' },
                      { nome: 'Maria Santos', email: 'maria@email.com', resultado: 'Não Ganhou', xp: 0, data: '15/01/2024 14:15' },
                      { nome: 'Pedro Costa', email: 'pedro@email.com', resultado: 'Ganhou', xp: 200, data: '15/01/2024 14:08' },
                      { nome: 'Ana Oliveira', email: 'ana@email.com', resultado: 'Não Ganhou', xp: 0, data: '15/01/2024 13:56' },
                      { nome: 'Carlos Souza', email: 'carlos@email.com', resultado: 'Ganhou', xp: 1000, data: '15/01/2024 13:45' },
                    ].map((log, index) => (
                      <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                        <td className="py-3 px-4">
                          <div>
                            <p className="text-sm font-medium text-gray-900">{log.nome}</p>
                            <p className="text-xs text-gray-600">{log.email}</p>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-center">
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                            log.resultado === 'Ganhou' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                          }`}>
                            {log.resultado}
                          </span>
                        </td>
                        <td className="py-3 px-4 text-center">
                          {log.xp > 0 ? (
                            <span className="text-sm font-bold text-yellow-600">{log.xp} XP</span>
                          ) : (
                            <span className="text-sm text-gray-400">-</span>
                          )}
                        </td>
                        <td className="py-3 px-4 text-center text-sm text-gray-700">{log.data}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowLogsModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Componente Rifa
function RifaAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showSorteioModal, setShowSorteioModal] = useState(false);
  const [showParticipantesModal, setShowParticipantesModal] = useState(false);
  const [selectedRifa, setSelectedRifa] = useState<any>(null);

  const rifas = [
    { id: 1, nome: 'Rifa Mega Prêmio', total_bilhetes: 1000, vendidos: 678, xp_bilhete: 20, premio: 'iPhone 15 Pro', data_sorteio: '31/01/2024', status: 'Ativa' },
    { id: 2, nome: 'Rifa Especial', total_bilhetes: 500, vendidos: 500, xp_bilhete: 15, premio: 'Notebook Dell', data_sorteio: '15/01/2024', status: 'Sorteado' },
  ];

  const handleEdit = (rifa: any) => {
    setSelectedRifa(rifa);
    setShowEditModal(true);
  };

  const handleSorteio = (rifa: any) => {
    setSelectedRifa(rifa);
    setShowSorteioModal(true);
  };

  const handleViewParticipantes = (rifa: any) => {
    setSelectedRifa(rifa);
    setShowParticipantesModal(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-gray-900">Rifas</h2>
        <button onClick={() => setShowModal(true)} className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
          <i className="ri-add-line mr-2"></i>
          Nova Rifa
        </button>
      </div>

      <div className="space-y-3">
        {rifas.map((rifa) => (
          <div key={rifa.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-lg font-bold text-gray-900">{rifa.nome}</h3>
                <p className="text-sm text-gray-600 mt-1">Prêmio: {rifa.premio}</p>
              </div>
              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                rifa.status === 'Ativa' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
              }`}>{rifa.status}</span>
            </div>
            <div className="grid grid-cols-4 gap-4 mb-3">
              <div>
                <p className="text-xs text-gray-600">Bilhetes Vendidos</p>
                <p className="text-sm font-bold text-teal-600">{rifa.vendidos}/{rifa.total_bilhetes}</p>
              </div>
              <div>
                <p className="text-xs text-gray-600">XP por Bilhete</p>
                <p className="text-sm font-bold text-yellow-600">{rifa.xp_bilhete} XP</p>
              </div>
              <div>
                <p className="text-xs text-gray-600">Data do Sorteio</p>
                <p className="text-sm font-bold text-gray-900">{rifa.data_sorteio}</p>
              </div>
              <div>
                <p className="text-xs text-gray-600">Progresso</p>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                  <div className="bg-teal-500 h-2 rounded-full" style={{ width: `${(rifa.vendidos / rifa.total_bilhetes) * 100}%` }}></div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button 
                onClick={() => handleEdit(rifa)}
                className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
              >
                <i className="ri-edit-line mr-2"></i>
                Editar
              </button>
              {rifa.status === 'Ativa' && (
                <button 
                  onClick={() => handleSorteio(rifa)}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  <i className="ri-trophy-line mr-2"></i>
                  Realizar Sorteio
                </button>
              )}
              <button 
                onClick={() => handleViewParticipantes(rifa)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium whitespace-nowrap"
              >
                <i className="ri-file-list-3-line mr-2"></i>
                Ver Participantes
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Nova Rifa */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Nova Rifa</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Rifa *</label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Prêmio *</label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Total de Bilhetes *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP por Bilhete *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data do Sorteio *</label>
                  <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Criar Rifa</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {showEditModal && selectedRifa && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Editar Rifa</h3>
              <button onClick={() => setShowEditModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Rifa *</label>
                <input type="text" defaultValue={selectedRifa.nome} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Prêmio *</label>
                <input type="text" defaultValue={selectedRifa.premio} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Total de Bilhetes *</label>
                  <input type="number" defaultValue={selectedRifa.total_bilhetes} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP por Bilhete *</label>
                  <input type="number" defaultValue={selectedRifa.xp_bilhete} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data do Sorteio *</label>
                  <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Salvar Alterações</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Realizar Sorteio */}
      {showSorteioModal && selectedRifa && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Realizar Sorteio</h3>
              <button onClick={() => setShowSorteioModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="text-center mb-6">
                <div className="w-24 h-24 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-trophy-line text-5xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{selectedRifa.nome}</h4>
                <p className="text-sm text-gray-600">Prêmio: {selectedRifa.premio}</p>
                <p className="text-sm text-gray-600 mt-1">{selectedRifa.vendidos} bilhetes vendidos</p>
              </div>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <div className="flex items-start gap-3">
                  <i className="ri-alert-line text-yellow-600 text-xl mt-0.5"></i>
                  <div>
                    <p className="text-sm font-medium text-yellow-900">Atenção!</p>
                    <p className="text-sm text-yellow-800 mt-1">Esta ação não pode ser desfeita. O sorteio será realizado imediatamente e o vencedor será selecionado aleatoriamente.</p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <p className="text-sm font-medium text-gray-900 mb-2">Bilhete Sorteado:</p>
                <div className="bg-white border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                  <p className="text-4xl font-bold text-purple-600">#0456</p>
                  <p className="text-sm text-gray-600 mt-2">João Silva</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowSorteioModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm font-medium whitespace-nowrap">
                <i className="ri-trophy-line mr-2"></i>
                Confirmar Sorteio
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Participantes */}
      {showParticipantesModal && selectedRifa && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Participantes da Rifa</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedRifa.nome}</p>
              </div>
              <button onClick={() => setShowParticipantesModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Participante</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Bilhetes</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Gasto</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { nome: 'João Silva', email: 'joao@email.com', bilhetes: 5, xp: 100, data: '10/01/2024' },
                      { nome: 'Maria Santos', email: 'maria@email.com', bilhetes: 3, xp: 60, data: '11/01/2024' },
                      { nome: 'Pedro Costa', email: 'pedro@email.com', bilhetes: 10, xp: 200, data: '12/01/2024' },
                      { nome: 'Ana Oliveira', email: 'ana@email.com', bilhetes: 2, xp: 40, data: '13/01/2024' },
                      { nome: 'Carlos Souza', email: 'carlos@email.com', bilhetes: 7, xp: 140, data: '14/01/2024' },
                    ].map((participante, index) => (
                      <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                        <td className="py-3 px-4">
                          <div>
                            <p className="text-sm font-medium text-gray-900">{participante.nome}</p>
                            <p className="text-xs text-gray-600">{participante.email}</p>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-center">
                          <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                            {participante.bilhetes} bilhetes
                          </span>
                        </td>
                        <td className="py-3 px-4 text-center text-sm font-bold text-yellow-600">{participante.xp} XP</td>
                        <td className="py-3 px-4 text-center text-sm text-gray-700">{participante.data}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowParticipantesModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Componente Palpites da Copa
function PalpitesAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showRankingModal, setShowRankingModal] = useState(false);
  const [showRodadasModal, setShowRodadasModal] = useState(false);
  const [selectedTemporada, setSelectedTemporada] = useState<any>(null);

  const temporadas = [
    { id: 1, nome: 'Copa do Mundo 2026', rodadas: 8, partidas: 64, palpites: 2345, xp_palpite: 10, xp_acerto: 50, status: 'Ativa' },
  ];

  const handleEdit = (temp: any) => {
    setSelectedTemporada(temp);
    setShowEditModal(true);
  };

  const handleViewRanking = (temp: any) => {
    setSelectedTemporada(temp);
    setShowRankingModal(true);
  };

  const handleViewRodadas = (temp: any) => {
    setSelectedTemporada(temp);
    setShowRodadasModal(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-gray-900">Palpites da Copa</h2>
        <button onClick={() => setShowModal(true)} className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
          <i className="ri-add-line mr-2"></i>
          Nova Temporada
        </button>
      </div>

      <div className="space-y-3">
        {temporadas.map((temp) => (
          <div key={temp.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-lg font-bold text-gray-900">{temp.nome}</h3>
                <p className="text-sm text-gray-600 mt-1">{temp.rodadas} rodadas • {temp.partidas} partidas</p>
              </div>
              <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">{temp.status}</span>
            </div>
            <div className="grid grid-cols-4 gap-4 mb-3">
              <div>
                <p className="text-xs text-gray-600">Total de Palpites</p>
                <p className="text-sm font-bold text-teal-600">{temp.palpites}</p>
              </div>
              <div>
                <p className="text-xs text-gray-600">XP por Palpite</p>
                <p className="text-sm font-bold text-yellow-600">{temp.xp_palpite} XP</p>
              </div>
              <div>
                <p className="text-xs text-gray-600">XP por Acerto</p>
                <p className="text-sm font-bold text-green-600">{temp.xp_acerto} XP</p>
              </div>
              <div>
                <p className="text-xs text-gray-600">Ações</p>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={() => handleEdit(temp)}
                    className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded transition-colors"
                    title="Editar"
                  >
                    <i className="ri-edit-line text-base"></i>
                  </button>
                  <button 
                    onClick={() => handleViewRodadas(temp)}
                    className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                    title="Gerenciar Rodadas"
                  >
                    <i className="ri-football-line text-base"></i>
                  </button>
                  <button 
                    onClick={() => handleViewRanking(temp)}
                    className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded transition-colors"
                    title="Ver Ranking"
                  >
                    <i className="ri-trophy-line text-base"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Nova Temporada */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Nova Temporada de Palpites</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Temporada *</label>
                <input type="text" placeholder="Ex: Copa do Mundo 2026" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP por Palpite *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP por Acerto *</label>
                  <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Criar Temporada</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {showEditModal && selectedTemporada && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">Editar Temporada de Palpites</h3>
              <button onClick={() => setShowEditModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Temporada *</label>
                <input type="text" defaultValue={selectedTemporada.nome} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP por Palpite *</label>
                  <input type="number" defaultValue={selectedTemporada.xp_palpite} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">XP por Acerto *</label>
                  <input type="number" defaultValue={selectedTemporada.xp_acerto} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Cancelar</button>
              <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">Salvar Alterações</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Gerenciar Rodadas */}
      {showRodadasModal && selectedTemporada && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Gerenciar Rodadas e Partidas</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedTemporada.nome}</p>
              </div>
              <button onClick={() => setShowRodadasModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6 space-y-6">
              {/* Rodada 1 */}
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 flex items-center justify-between">
                  <h4 className="text-sm font-bold text-gray-900">Rodada 1 - Fase de Grupos</h4>
                  <button className="px-3 py-1 bg-teal-600 text-white rounded text-xs font-medium hover:bg-teal-700 transition-colors whitespace-nowrap">
                    <i className="ri-add-line mr-1"></i>
                    Nova Partida
                  </button>
                </div>
                <div className="divide-y divide-gray-100">
                  {[
                    { time1: 'Brasil', time2: 'Argentina', placar1: 2, placar2: 1, data: '15/06/2026 16:00', status: 'Finalizado' },
                    { time1: 'Alemanha', time2: 'França', placar1: null, placar2: null, data: '15/06/2026 19:00', status: 'Agendado' },
                  ].map((partida, index) => (
                    <div key={index} className="p-4 hover:bg-gray-50">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4 flex-1">
                          <div className="text-right flex-1">
                            <p className="text-sm font-medium text-gray-900">{partida.time1}</p>
                          </div>
                          <div className="flex items-center gap-3">
                            <input 
                              type="number" 
                              value={partida.placar1 ?? ''} 
                              placeholder="-"
                              className="w-12 h-12 text-center text-lg font-bold border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                            />
                            <span className="text-gray-400 font-bold">×</span>
                            <input 
                              type="number" 
                              value={partida.placar2 ?? ''} 
                              placeholder="-"
                              className="w-12 h-12 text-center text-lg font-bold border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                            />
                          </div>
                          <div className="flex-1">
                            <p className="text-sm font-medium text-gray-900">{partida.time2}</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-3 ml-6">
                          <div className="text-right">
                            <p className="text-xs text-gray-600">{partida.data}</p>
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1 ${
                              partida.status === 'Finalizado' ? 'bg-gray-100 text-gray-800' : 'bg-blue-100 text-blue-800'
                            }`}>
                              {partida.status}
                            </span>
                          </div>
                          <button className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded transition-colors">
                            <i className="ri-save-line text-base"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowRodadasModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Ranking */}
      {showRankingModal && selectedTemporada && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 bg-white">
              <div>
                <h3 className="text-xl font-bold text-gray-900">Ranking de Palpites</h3>
                <p className="text-sm text-gray-600 mt-1">{selectedTemporada.nome}</p>
              </div>
              <button onClick={() => setShowRankingModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Posição</th>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Participante</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Palpites</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Acertos</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Taxa</th>
                      <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Ganho</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { posicao: 1, nome: 'João Silva', email: 'joao@email.com', palpites: 45, acertos: 32, taxa: 71, xp: 1850 },
                      { posicao: 2, nome: 'Maria Santos', email: 'maria@email.com', palpites: 42, acertos: 28, taxa: 67, xp: 1620 },
                      { posicao: 3, nome: 'Pedro Costa', email: 'pedro@email.com', palpites: 40, acertos: 25, taxa: 63, xp: 1450 },
                      { posicao: 4, nome: 'Ana Oliveira', email: 'ana@email.com', palpites: 38, acertos: 23, taxa: 61, xp: 1330 },
                      { posicao: 5, nome: 'Carlos Souza', email: 'carlos@email.com', palpites: 35, acertos: 20, taxa: 57, xp: 1200 },
                    ].map((participante) => (
                      <tr key={participante.posicao} className="border-t border-gray-100 hover:bg-gray-50">
                        <td className="py-3 px-4">
                          <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold ${
                            participante.posicao === 1 ? 'bg-yellow-100 text-yellow-800' : 
                            participante.posicao === 2 ? 'bg-gray-200 text-gray-800' : 
                            participante.posicao === 3 ? 'bg-orange-100 text-orange-800' :
                            'bg-gray-100 text-gray-700'
                          }`}>
                            {participante.posicao}º
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <div>
                            <p className="text-sm font-medium text-gray-900">{participante.nome}</p>
                            <p className="text-xs text-gray-600">{participante.email}</p>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-center text-sm text-gray-900">{participante.palpites}</td>
                        <td className="py-3 px-4 text-center text-sm font-bold text-green-600">{participante.acertos}</td>
                        <td className="py-3 px-4 text-center text-sm text-gray-900">{participante.taxa}%</td>
                        <td className="py-3 px-4 text-center text-sm font-bold text-yellow-600">{participante.xp} XP</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
              <button onClick={() => setShowRankingModal(false)} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap">Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
